import React from 'react'
import styled from 'styled-components'
import _ from 'lodash'
import { FormattedMessage } from 'react-intl'

import Button from '../../atoms/Button'
import SelectableButton from '../../molecules/SelectableButton'
import ResearchAddTerritoryModal from '../../organisms/ResearchAddTerritoryModal'
import Card from '../../atoms/Card'
import CloseableBadge from '../../atoms/CloseableBadge'

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

const ButtonRow = styled.div`
  display: flex;
`

const StyledButton = styled(Button)`
  margin: 10px;
`

const StyledCloseableBadge = styled(CloseableBadge)`
  margin-right: 10px;
  margin-bottom: 10px;
`

const StyledSelectableButton = styled(SelectableButton)`
  margin: 10px;
`

export default class ResearchSelectedTerritoriesList extends React.PureComponent {
  static defaultProps = {
    badges: [],
    isModalAddButtonDisabled: true,
    isModalAddAllButtonDisabled: true,
    onAddAllTerritoriesModalClick: () => {},
    onAddTerritoriesModalClick: () => {},
    onChangeTerritoryType: () => {},
    onCleanTerritoriesClick: () => {},
    selectedTerritoryType: 'biomes'
  }

  state = {
    isLoadingAddAll: false,
    isModalOpen: false
  }

  toggleModal = () => {
    if (this.state.isModalOpen) {
      this.props.onModalClose()
    }

    this.setState({
      isModalOpen: !this.state.isModalOpen
    })
  }

  handleAddAllClick = async () => {
    this.setState({
      isLoadingAddAll: true
    }, () => {
      // Wrapping this in an async function means we don't have to test
      // if the function returns a promise or not, as await will treat that
      (async () => {
        await this.props.onAddAllTerritoriesModalClick()
      })().then(() => {
        this.setState({
          isLoadingAddAll: false
        })
        this.toggleModal()
      })
    })
  }

  handleAddClick = () => {
    this.props.onAddTerritoriesModalClick()
    this.toggleModal()
  }

  renderBadge(badge) {
    return (
      <StyledCloseableBadge
        onCloseClick={ badge.onCloseClick }
      >
        { badge.content }
      </StyledCloseableBadge>
    )
  }

  renderBadges() {
    return _.map(this.props.badges, this.renderBadge)
  }

  handleBiomesButtonClick = () => {
    if (this.props.selectedTerritoryType !== 'biomes') {
      this.props.onChangeTerritoryType('biomes')
    }
  }

  handleRegionsButtonClick = () => {
    if (this.props.selectedTerritoryType !== 'regions') {
      this.props.onChangeTerritoryType('regions')
    }
  }

  render() {
    return (
      <div>
        <ButtonContainer>
          <ButtonRow>
            <StyledSelectableButton
              onClick={ this.handleRegionsButtonClick }
              selected={ this.props.selectedTerritoryType === 'regions' }
            >
              survey.territories.type_button_regions
            </StyledSelectableButton>
          {/* <StyledSelectableButton
          onClick={ this.handleBiomesButtonClick }
          selected={ this.props.selectedTerritoryType === 'biomes' }
          >
          survey.territories.type_button_biomes
          </StyledSelectableButton> */}
          </ButtonRow>
          <ButtonRow>
            <StyledButton
              onClick={
                this.props.onCleanTerritoriesClick
              }
            >
              survey.territories.button_remove_all
            </StyledButton>
            <StyledButton
              onClick={ this.toggleModal }
            >
              survey.territories.button_add_new_territory
            </StyledButton>
          </ButtonRow>
        </ButtonContainer>
        <ResearchAddTerritoryModal
          isAddDisabled={ this.props.isModalAddButtonDisabled }
          isAddAllDisabled={ this.props.isModalAddAllButtonDisabled }
          isLoadingAddAll={ this.state.isLoadingAddAll }
          isOpen={ this.state.isModalOpen }
          onAddAllClick={ this.handleAddAllClick }
          onAddClick={ this.handleAddClick }
          toggle={ this.toggleModal }
        />
        <Card>
          <div>
            { this.renderBadges() }
          </div>
        </Card>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/ResearchSelectedTerritoriesList/ResearchSelectedTerritoriesList.js